import React from 'react';

const BasicInformationSection = ({ updatedClient, data, updateField }) => {
    return (
        <div className='mb-2'>
            <div className='mb-2'>
                <input required placeholder={data.t.read("client_table.client_name")}
                    className='form-control' type="text" value={updatedClient.name || ""}
                    onChange={(e) => updateField("name", e.target.value)}
                />
            </div>
            <div className='mb-2'>
                <input placeholder={data.t.read("client_table.client_email")}
                    className='form-control' type="text"
                    value={updatedClient.emails || ""}
                    onChange={(e) => updateField("emails", e.target.value)} />
            </div>
        </div>
    );
};

export default BasicInformationSection;
